/* eslint-disable sort-keys-fix/sort-keys-fix */
import base from "./base"
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/saman/"

const saman: CommunityData = {
  code: "saman",
  inviteCode: "saman",
  name: "SAM/AN",
  publicEventPages: true,
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/saman`,
  socials: {},
  styles: {
    ...base.styles,
    global: {
      counterColor: "#ecd2b2",
      inviteGate: {
        mobileLayout: "joinFirst",
      },
      werzLogoColor: "#FFFFFF",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[190px] h-[48px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[190px] h-[48px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#111111",
      asideBg: "#000000",
      asideStyles:
        "!p-0 !gap-0 border-r border-solid [border-image:linear-gradient(to_bottom,#916e44_0%,#ecb97d_14%,#ecd2b2_24%,#916e44_37%,#ecb97d_54%,#ecd2b2_78%,#ecb97d_100%)_1]",
      contentBg: "#111111",
      contentBoxShadow: "",
      bgDesktop: ``,
      bgMobile: ``,
      nonMemberBg: `${S3_PREFIX}web-bg-cropped.jpg`,
      nonMemberBgContainerStyles:
        "sm:!h-screen !bg-[#000000] flex items-center justify-center sm:!p-12 p-6",
      nonMemberBgStyles: "max-w-full max-h-full w-auto h-auto object-contain",
      mainFont: "font-['EBGaramondRegular']",
      primaryButton:
        "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[18px] py-[18px] !text-[#ecd2b2] font-['EBGaramondRegular'] !text-[20px] text-left",
    },
    navigation: {
      iconsColor: "#ecb97d",
      sideBarSeparator:
        "border-r-[1px] border-solid [border-image:linear-gradient(to_bottom,#916e44_0%,#ecb97d_14%,#ecd2b2_24%,#916e44_37%,#ecb97d_54%,#ecd2b2_78%,#ecb97d_100%)_1]",
      separator: "border-[#916e44]",
      item: "font-['EBGaramondRegular'] text-[16px] text-[#ecb97d] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#916e44] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#111111] border border-[#ecb97d] rounded-lg !pb-8",
      titles:
        "text-[#ecb97d] font-['EBGaramondRegular'] text-[28px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%]",
      announcementsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid [border-image:linear-gradient(to_right,#916e44_0%,#ecb97d_14%,#ecd2b2_24%,#916e44_37%,#ecb97d_54%,#ecd2b2_78%,#ecb97d_100%)_1]",
        sectionTitle:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[28px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#101010]",
          mediaContainer:
            "w-full sm:w-[256px] h-[256px] sm:h-[256px] relative rounded-lg overflow-hidden",
          media: "w-full h-[256px] object-cover rounded-lg",
          placeholderMedia: "w-full h-[256px] bg-gray-400 rounded-lg",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ecb97d] font-['EBGaramondRegular'] text-[20px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#ecd2b2] font-['EBGaramondRegular'] text-[14px] text-left leading-[110%] mt-2 hidden",
        },
      },
      eventsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid [border-image:linear-gradient(to_right,#916e44_0%,#ecb97d_14%,#ecd2b2_24%,#916e44_37%,#ecb97d_54%,#ecd2b2_78%,#ecb97d_100%)_1]",
        sectionTitle:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[28px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#101010]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:h-[128px] h-[180px] sm:flex-shrink-0 relative rounded-lg overflow-hidden",
          media: "w-full sm:!w-[228px] sm:h-[128px] h-[180px] object-cover rounded-lg",
          placeholderMedia: "w-full sm:!w-[228px] sm:h-[128px] h-[180px] bg-gray-400 rounded-lg",
          content: "flex flex-col sm:px-4 py-0 py-4 bg-transparent",
          title:
            "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#ecd2b2] font-['EBGaramondRegular'] text-[14px] text-left leading-[110%] mt-2",
          location:
            "text-[#ecd2b2] font-['EBGaramondRegular'] text-[14px] text-left leading-[110%] mt-1",
          date: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[14px] text-left leading-[110%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[18px] text-left leading-[110%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[28px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    shopV2: {
      container: "mb-16 sm:p-8 p-4 sm:pb-8 !bg-[#111111] border border-[#ecb97d] rounded-lg",
      header:
        "text-[#ecb97d] font-['EBGaramondRegular'] text-[28px] uppercase text-left leading-[110%]",
      emptyState: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%]",
      membershipSection: {
        container: "mb-8",
        header:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%] mb-4",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            container:
              "flex flex-row justify-between gap-4 leading-auto border-b border-[#916e44] py-4 mb-4",
            media: "!hidden",
            mediaContainer: "",
            name: "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
            description:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%] !mt-1",
            price:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%] !mt-1",
            quantity:
              "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] text-left leading-[100%]",
            status:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
            plusMinusColor: "#ecd2b2",
            button:
              "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[12px] py-[12px] text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] text-left leading-[100%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      eventSection: {
        container: "mb-8",
        header:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%] mb-4",
        event: {
          container: "flex items-start gap-4 mb-4",
          dateBox:
            "bg-[#000000] p-2 w-[52px] h-[52px] flex flex-col items-center justify-center text-center rounded-lg border border-[#ecb97d]",
          month: "text-xs font-['EBGaramondRegular'] uppercase leading-[16px] text-[#ecb97d]",
          day: "text-base font-['EBGaramondRegular'] uppercase leading-[16px] text-[#ecd2b2]",
          details: "flex-1",
          name: "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
          date: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[14px] text-left leading-[110%] mt-1",
          location:
            "text-[#ecd2b2] font-['EBGaramondRegular'] text-[14px] text-left leading-[110%] mt-1",
        },
        tickets: {
          container: "flex flex-col overflow-hidden",
          ticket: {
            container:
              "flex flex-row justify-between gap-4 leading-auto border-b border-[#916e44] pb-2 mb-2",
            media: "!hidden",
            mediaContainer: "",
            name: "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
            description:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%] !mt-1",
            price:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%] !mt-1",
            quantity:
              "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] text-left leading-[100%]",
            status:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
            plusMinusColor: "#ecd2b2",
            button:
              "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[12px] py-[12px] text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] text-left leading-[100%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      merchSection: {
        container: "mb-8",
        header:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%] mb-4",
        products: {
          container: "grid grid-cols-3 gap-4",
          product: {
            container: "cursor-pointer",
            innerContainer: "flex flex-col",
            media: "w-full !aspect-square object-cover rounded-lg",
            mediaContainer: "w-full rounded-lg overflow-hidden",
            name: "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%] mt-3",
            description:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[14px] text-left leading-[110%] !mt-1",
            price:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%] !mt-2",
            quantity: "!hidden",
            status:
              "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
            counterContainer: "!hidden",
            plusMinusColor: "#ecd2b2",
            button: "!hidden",
            descriptionCutoff: 50,
          },
        },
      },
    },
    shopProductV2: {
      container: "flex flex-col sm:p-8 p-4 !bg-[#111111] border border-[#ecb97d] rounded-lg",
      media: "w-full sm:!h-[486px] object-cover rounded-lg",
      title:
        "text-[#ecb97d] font-['EBGaramondRegular'] text-[28px] uppercase text-left leading-[110%] mt-6",
      additionalDetails:
        "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%] mt-4",
      priceSection: "border-t border-[#916e44] mt-6 pt-6",
      displayPrice:
        "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%]",
      shortTerms: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[12px] text-left mt-2",
      variantSelector: {
        section: "mt-6 space-y-4 !hidden",
        separator: "flex items-center justify-between border-t border-[#916e44] pt-4",
        label: "text-sm font-['EBGaramondRegular'] uppercase text-[#ecb97d]",
        sizeButton:
          "px-4 py-2 border border-[#ecb97d] bg-[#000000] text-[#ecd2b2] rounded-[4px] hover:border-[#ecd2b2] transition-all font-['EBGaramondRegular']",
        sizeButtonSelected:
          "px-4 py-2 border border-[#ecb97d] bg-[#ecb97d] text-[#111111] rounded-[4px] font-['EBGaramondRegular']",
        sizeButtonOneSize:
          "px-4 py-2 border border-[#ecb97d] bg-[#ecb97d] text-[#111111] rounded-[4px] cursor-default font-['EBGaramondRegular']",
        colorSwatchContainer: "flex gap-3 items-center",
        colorSwatch:
          "w-10 h-10 rounded-full border-4 border-[#916e44] hover:border-[#ecd2b2] transition-all",
        colorSwatchSelected:
          "w-10 h-10 rounded-full border-4 border-[#ecb97d] scale-110 transition-all",
        validationMessage:
          "text-[#ecd2b2] font-['EBGaramondRegular'] text-sm mt-2 border-t border-[#916e44] pt-4",
      },
      counter: {
        container:
          "flex items-center gap-4 border border-[#ecb97d] bg-[#000000] rounded-[4px] px-4 py-3",
        quantity: "text-lg font-['EBGaramondRegular'] text-[#ecd2b2] min-w-[20px] text-center",
        plusMinusColor: "#ecd2b2",
      },
      button:
        "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[18px] py-[18px] text-[#ecd2b2] font-['EBGaramondRegular'] !text-[20px] text-left leading-[100%] !w-fit self-center",
    },
    eventV2: {
      container: "flex flex-col !bg-[#111111] border border-[#ecb97d] rounded-lg !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-solid [border-image:linear-gradient(to_right,#916e44_0%,#ecb97d_14%,#ecd2b2_24%,#916e44_37%,#ecb97d_54%,#ecd2b2_78%,#ecb97d_100%)_1]",
        media:
          "sm:!w-[320px] !w-full sm:!h-[180px] !h-[180px] object-cover sm:mb-4 !border-0 rounded-lg",
        title:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[28px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 gap-y-[6px] text-[#ecd2b2] font-['EBGaramondRegular'] !text-[20px] text-left leading-[100%]",
        questions: "text-[16px] text-left leading-[110%] text-[#ecd2b2]",
      },
      about: {
        container:
          "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid [border-image:linear-gradient(to_right,#916e44_0%,#ecb97d_14%,#ecd2b2_24%,#916e44_37%,#ecb97d_54%,#ecd2b2_78%,#ecb97d_100%)_1]",
        header:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%] mb-4 w-full",
      },
      location: {
        container:
          "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid [border-image:linear-gradient(to_right,#916e44_0%,#ecb97d_14%,#ecd2b2_24%,#916e44_37%,#ecb97d_54%,#ecd2b2_78%,#ecb97d_100%)_1]",
        header:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] rounded-lg",
        mapPinColor: "#ecb97d",
        mapStrokeColor: "#ecb97d00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%]",
      },
      tickets: {
        header:
          "text-[#ecb97d] font-['EBGaramondRegular'] text-[24px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#111111] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[12px] py-[12px] text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#916e44] sm:py-4 py-2",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] text-left leading-[110%] mb-1 flex flex-row",
          price:
            "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] text-left leading-[100%]",
          status:
            "text-[#ecd2b2] font-['EBGaramondRegular'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#ecb97d] rounded-[4px] px-[12px] py-[12px] text-[#ecb97d] font-['EBGaramondRegular'] text-[16px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ecd2b2",
        },
      },
    },
  },
}

export default saman
